// extracted by mini-css-extract-plugin
export default {"drawer":"EdtEmailTemplateDrawer_drawer__vX3cC"};